const GameState = {
  playerXWins: 0,
  playerOWins: 1,
  draws: 2,
  inProgress: 3,
};

export default GameState;
